export const DEFAULT_IMAGE = "/images/default-blog.png";
